"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M14.775 13.086H12.5V10.81a.5.5 0 1 0-1 0v2.275H9.224a.5.5 0 1 0 0 1H11.5v2.276a.499.499 0 1 0 1 0v-2.276h2.275a.5.5 0 0 0 0-1Zm1.077 4.352A5.413 5.413 0 0 1 12 19.034a5.412 5.412 0 0 1-3.851-1.596 5.41 5.41 0 0 1-1.596-3.853c0-1.455.567-2.823 1.596-3.852A5.412 5.412 0 0 1 12 8.137c1.457 0 2.824.567 3.853 1.596a5.412 5.412 0 0 1 1.596 3.852 5.411 5.411 0 0 1-1.596 3.853ZM12 7.138a6.405 6.405 0 0 0-4.56 1.887 6.405 6.405 0 0 0-1.889 4.56c0 1.722.671 3.341 1.89 4.56a6.405 6.405 0 0 0 4.558 1.888 6.406 6.406 0 0 0 4.56-1.889 6.406 6.406 0 0 0 1.89-4.56 6.405 6.405 0 0 0-1.89-4.559A6.406 6.406 0 0 0 12 7.137ZM23 21.12c0 .599-.487 1.086-1.086 1.086H2.086A1.087 1.087 0 0 1 1 21.121V6.052c0-.599.487-1.087 1.086-1.087h19.828c.599 0 1.086.488 1.086 1.087v15.069ZM8.138 2.879c0-.599.487-1.086 1.086-1.086h5.551c.6 0 1.087.487 1.087 1.086v1.086H8.138V2.879Zm13.776 1.086h-5.052V2.879c0-1.15-.936-2.086-2.087-2.086H9.224c-1.15 0-2.086.936-2.086 2.086v1.086H2.086C.936 3.965 0 4.901 0 6.052v15.069c0 1.15.936 2.086 2.086 2.086h19.828c1.15 0 2.086-.936 2.086-2.086V6.052a2.089 2.089 0 0 0-2.086-2.087Z",
    clipRule: "evenodd"
  })]
});